import type { CSSProperties } from 'react';
import { useTranslation } from 'react-i18next';
import { tokens } from '../../theme';

interface MobileHeaderProps {
  name: string;
  onBack: () => void;
}

const styles = {
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.space[3],
    paddingTop: `calc(${tokens.space[3]} + max(env(safe-area-inset-top, 0px), var(--avatar-safe-top)))`,
    paddingRight: tokens.space[4],
    paddingBottom: tokens.space[3],
    paddingLeft: tokens.space[4],
    flexShrink: 0,
    background: tokens.surface.canvas,
  },
  backBtn: {
    width: 44,
    height: 44,
    borderRadius: '50%',
    border: `1px solid ${tokens.border.default}`,
    background: tokens.icon.targetBg,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    padding: 0,
    margin: 0,
    lineHeight: 0,
    appearance: 'none',
    WebkitAppearance: 'none',
  },
  backIcon: {
    display: 'block',
    flexShrink: 0,
  },
  textBlock: {
    flex: 1,
    minWidth: 0,
  },
  title: {
    margin: 0,
    fontSize: 20,
    fontWeight: tokens.font.weight.bold,
    color: tokens.text.primary,
    letterSpacing: '-0.01em',
    lineHeight: tokens.font.lineHeight.tight,
  },
  subtitle: {
    margin: '2px 0 0',
    fontSize: 16,
    fontWeight: tokens.font.weight.regular,
    color: tokens.text.secondary,
    lineHeight: 1.3,
  },
} as const satisfies Record<string, CSSProperties>;

export default function MobileHeader({ name, onBack }: MobileHeaderProps) {
  const { t } = useTranslation();

  return (
    <header style={styles.header}>
      <button
        type="button"
        style={styles.backBtn}
        onClick={onBack}
        aria-label={t('mobile.back')}
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          aria-hidden="true"
          style={styles.backIcon}
        >
          <path
            d="M14 6l-6 6 6 6"
            stroke={tokens.text.secondary}
            strokeWidth="2.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
      <div style={styles.textBlock}>
        <h1 style={styles.title}>{name}</h1>
        <p style={styles.subtitle}>{t('mobile.subtitle', { name })}</p>
      </div>
    </header>
  );
}
